module.exports = __webpack_public_path__ + "img/greece.687a15ea.svg";